import React from "react";

const GetInTouch = () => {
   return (
      <div className="GetInTouch" id="contact">
         <div className="inner-wrapper">
            <div>
               <h3 className="title-color"><span>04.</span> Reach out to me</h3>
               <p className="job-description">I'm currently looking for a Software Engineer, Full Stack, Front End or Back End position. Let's get in touch! Send me an email and I will get back to you!.</p>
               <div className="email-me">
                  <a href="mailto:anthonyamaro5555@gmail.com">
                     Get in touch
                  </a>
               </div>             
            </div>
        
         </div>
      </div>
   )
}

export default GetInTouch;